module.exports = __webpack_public_path__ + "static/maxLevel.3080369e.png";